@let s = pageState();
@if (s.kind === 'pending') {
  <div class="bg-slate-50 min-h-screen" aria-busy="true" aria-live="polite">
    <app-marketing-header variant="home" />
    <div class="cg-container--marketing flex flex-col items-center justify-center gap-4 py-24 text-slate-500">
      <span
        class="h-10 w-10 animate-spin rounded-full border-2 border-slate-300 border-t-slate-700"
        aria-hidden="true"
      ></span>
      <p class="text-sm">Loading…</p>
    </div>
  </div>
} @else if (s.kind === 'error') {
  <div class="cg-container--marketing py-16 text-center">
    <h1 class="text-xl font-semibold text-slate-800">Article not found</h1>
    <a routerLink="/blogs" class="cg-mkt-btn cg-mkt-btn--primary mt-6 inline-block">Back to blogs</a>
  </div>
} @else {
  <div class="bg-slate-50 min-h-screen">
    <app-marketing-header variant="home" />
    <article class="cg-blog-article">
      <div class="cg-container--marketing cg-blog-article__inner">
        <app-marketing-blog-breadcrumb
          [currentTitle]="s.page.post.title"
          [categoryName]="s.page.categories[0]?.name"
          [categorySlug]="s.page.categories[0]?.slug"
        />
        <header class="cg-blog-article__header">
          @if (s.page.categories.length) {
            <div class="cg-blog-article__chips">
              @for (cat of s.page.categories; track cat.slug) {
                <a [routerLink]="['/blogs/category', cat.slug]" class="cg-blog-article__chip">{{ cat.name }}</a>
              }
            </div>
          }
          <h1 class="cg-blog-article__title">{{ s.page.post.title }}</h1>
          <p class="cg-blog-article__excerpt">{{ s.page.post.excerpt }}</p>
          <div class="cg-blog-article__meta">
            @if (s.page.author) {
              <span>{{ s.page.author.displayName }}</span>
            }
            @if (s.page.post.publishedAt) {
              <time [dateTime]="s.page.post.publishedAt">{{ formatDate(s.page.post.publishedAt) }}</time>
            }
            <span>{{ s.page.post.readingTimeMinutes }} min read</span>
          </div>
        </header>
        @if (s.page.featuredImage?.cdnUrl) {
          <figure class="cg-blog-article__hero">
            <img
              [src]="s.page.featuredImage!.cdnUrl"
              [alt]="s.page.featuredImage!.alt || s.page.post.title"
              width="1200"
              height="630"
            />
          </figure>
        }
        <app-blog-renderer [content]="s.page.post.content" />
        <app-marketing-blog-guide-download [guide]="s.page.downloadableGuide" />
        <app-marketing-consultation-cta
          [cta]="s.page.consultationCta"
          [sourcePage]="sourcePage(s.page.post.slug)"
        />
        <app-marketing-blog-related [posts]="s.page.relatedPosts" />
      </div>
    </article>
    <app-marketing-footer />
  </div>
}
